import React, { useEffect } from "react";
import "./App.css";
import "./index.css";
import "./components/common_components/common_css/table_css/table_css.css";
import "./components/common_components/common_css/custom_modal_css/custom_modal_css.css";
import "./components/common_components/common_css/form_css/form_css.css";
import "./components/common_components/common_css/action_btn_css/action_btn_css.css";
import "./components/common_components/common_css/swiper_css/swiper_css.css";
import "./components/common_components/common_css/btn_css/btn_css.css";
import "./components/common_components/common_css/common_offcanvas_css/Common_offcanvas_css.css";

import { Route, Routes } from "react-router-dom";
import ScrollToTop from "./components/ScrollTotop/ScrollTotop";
import User_Login from "./components/user-login/User_Login";
import User_registration from "./components/user-login/registration/User_registration";
import Dashboard from "./components/dashboard/Dashboard";

//College registration

import College_registration from "./components/registration_forms/collageRegistration/CollageRegistration.js";

// Hotel registration
import Hotel_registration from "./components/registration_forms/hotelRegistration/HotelRegistration.js";

/* ---------- STUDENT ---------- */
import Dashboard_Content from "./components/dashboard/dashboard_components/student_portal/dashboard_Content/Dashboard_Content";
import Applications_Section from "./components/dashboard/dashboard_components/student_portal/applications-section/Applications_Section";
import Documents_Management from "./components/dashboard/dashboard_components/student_portal/documents_Management/Documents_Management";
import To_do_task_managment from "./components/dashboard/dashboard_components/student_portal/to_do_task_managment/To_do_task_managment";
import Study_Program from "./components/dashboard/dashboard_components/student_portal/applications-section/study-program/Study_Program";
import Internship_Program from "./components/dashboard/dashboard_components/student_portal/applications-section/internship-program/Internship_Program";
import Billing_manegment from "./components/dashboard/dashboard_components/student_portal/billing_manegment/Billing_manegment";
import Language_Test from "./components/dashboard/dashboard_components/student_portal/language_Test/Language_Test";
import Language_test_step_form from "./components/dashboard/dashboard_components/student_portal/language_Test/language_test_step_form/Language_test_step_form";
import Result from "./components/dashboard/dashboard_components/student_portal/language_Test/Result/Result";
import Support from "./components/dashboard/dashboard_components/student_portal/support/Support";
import Profile from "./components/dashboard/dashboard_components/student_portal/profile/Profile";

/* ---------- COLLEGE ---------- */
import Collage_dashboard from "./components/dashboard/dashboard_components/collage_portal/collage_dashboard/Collage_dashboard";
import Collage_intern from "./components/dashboard/dashboard_components/collage_portal/collage_intern/Collage_intern";
import Collage_offer from "./components/dashboard/dashboard_components/collage_portal/collage_offer/Collage_offer";
import Global_map from "./components/dashboard/dashboard_components/collage_portal/collage_global_map/Global_map";
import Collage_portal_documents from "./components/dashboard/dashboard_components/collage_portal/collage_portal_documents/Collage_portal_documents";
import Collage_Profile from "./components/dashboard/dashboard_components/collage_portal/collage_profile/Collage_Profile";

/* ---------- HOTEL ---------- */
import Hotel_dashboard from "./components/dashboard/dashboard_components/hotel_portal/hotel_dashboard/Hotel_dashboard";
import Hotel_intern from "./components/dashboard/dashboard_components/hotel_portal/hotel_intern/Hotel_intern";
import Hotel_application from "./components/dashboard/dashboard_components/hotel_portal/hotel_intern/hotel_application/Hotel_application";
import Hotel_Global_map from "./components/dashboard/dashboard_components/hotel_portal/hotel_global_map/Hotel_Global_map";
import Hotel_portal_documents from "./components/dashboard/dashboard_components/hotel_portal/hotel_portal_documents/Hotel_portal_documents";
import Hotel_Profile from "./components/dashboard/dashboard_components/hotel_portal/hotel_profile/Hotel_Profile";
import Admin_dashboard from "./components/dashboard/dashboard_components/admin-portal/admin_dashboard/Admin_dashboard";
import Admin_Profile from "./components/dashboard/dashboard_components/admin-portal/admin_Profile/Admin_Profile";
import Country from "./components/dashboard/dashboard_components/admin-portal/admin_master/country/Country";
import State from "./components/dashboard/dashboard_components/admin-portal/admin_master/state/State";
import City from "./components/dashboard/dashboard_components/admin-portal/admin_master/city/City";
import Pincode from "./components/dashboard/dashboard_components/admin-portal/admin_master/pincode/Pincode";
import Faq from "./components/dashboard/dashboard_components/admin-portal/admin_master/faq/Faq.js";
import StudentDocument from "./components/dashboard/dashboard_components/admin-portal/admin_master/student_document/StudentDocument.js";

import Ticket from "./components/dashboard/dashboard_components/admin-portal/admin_support/ticket/Ticket.js";

import Role from "./components/dashboard/dashboard_components/admin-portal/admin_user_management/role/Role";
import Student from "./components/dashboard/dashboard_components/admin-portal/admin_user_management/student/Student";
import College from "./components/dashboard/dashboard_components/admin-portal/admin_user_management/college/College";
import Hotel from "./components/dashboard/dashboard_components/admin-portal/admin_user_management/hotel/Hotel";

import Program_Highlight from "./components/dashboard/dashboard_components/admin-portal/admin_courses/programhighlight/Program_Highlight";
import Eligibility_Requirement from "./components/dashboard/dashboard_components/admin-portal/admin_courses/eligibilityrequirement/Eligibility_Requirement";
import Career_Requirement from "./components/dashboard/dashboard_components/admin-portal/admin_courses/careerrequirement/Career_Requirement";
import Requirement_Documents from "./components/dashboard/dashboard_components/admin-portal/admin_courses/requirementdocuments/Requirement_Documents";
import University from "./components/dashboard/dashboard_components/admin-portal/admin_courses/university/University.js";
import Course from "./components/dashboard/dashboard_components/admin-portal/admin_courses/course/Course.js";
import Accomodation from "./components/dashboard/dashboard_components/admin-portal/admin_courses/accomodation/Accomodation.js";
import Study_Programs from "./components/dashboard/dashboard_components/admin-portal/admin_courses/studyprogram/Study_Programs.js";

import Document from "./components/dashboard/dashboard_components/admin-portal/admin_internship/document/Document";
import Requirement from "./components/dashboard/dashboard_components/admin-portal/admin_internship/requirement/Requirement";
import Internship from "./components/dashboard/dashboard_components/admin-portal/admin_internship/internship/Internship.js";

//------------------------------------------------------------------------- Website ----------------------------------------------------------------------------

import WhyChooseUS from "./components/dashboard/dashboard_components/admin-portal/website/home/WhyChooseUS/Table.js";
import WhoWeAre from "./components/dashboard/dashboard_components/admin-portal/website/home/WhoWeAre/Table.js";
import SuccessSpeaks from "./components/dashboard/dashboard_components/admin-portal/website/home/SuccessSpeaks/Table.js";
import HomeFaq from "./components/dashboard/dashboard_components/admin-portal/website/home/HomeFaq/Table.js";

// About us
import OurStory from "./components/dashboard/dashboard_components/admin-portal/website/aboutus/OurStory/Table.js";

//website Contact us
import GetInTouch from "./components/dashboard/dashboard_components/admin-portal/website/contact_us/GetInTouch/Table.js";

//Admin Contact us
import ContactUs from "./components/dashboard/dashboard_components/admin-portal/admin_contact_us/ContactUs/Table.js";

// Admin need Advice
import NeedAdvice from "./components/dashboard/dashboard_components/admin-portal/admin_need_advice/NeedAdvice/Table.js";

function App() {
  return (
    <>
      <ScrollToTop />

      <Routes>
        {/* Login */}
        <Route path="/" element={<User_Login />} />
        <Route path="user-register" element={<User_registration />} />
        <Route path="college-register" element={<College_registration />} />
        <Route path="hotel-register" element={<Hotel_registration />} />

        {/* ================= COMMON DASHBOARD ================= */}
        <Route path="/portal/:role" element={<Dashboard />}>
          {/* ---------- STUDENT ROUTES ---------- */}
          <Route path="dashboard" element={<Dashboard_Content />} />
          <Route path="applications" element={<Applications_Section />} />
          <Route path="documents" element={<Documents_Management />} />
          <Route path="todo-task" element={<To_do_task_managment />} />
          <Route path="study-program" element={<Study_Program />} />
          <Route path="internship-program" element={<Internship_Program />} />
          <Route path="billing-manegment" element={<Billing_manegment />} />
          <Route path="language-test" element={<Language_Test />} />
          <Route
            path="language-test-step-form"
            element={<Language_test_step_form />}
          />
          <Route path="result" element={<Result />} />
          <Route path="support" element={<Support />} />
          <Route path="profile" element={<Profile />} />

          {/* ---------- COLLEGE ROUTES ---------- */}
          <Route path="college-dashboard" element={<Collage_dashboard />} />
          <Route path="college-intern" element={<Collage_intern />} />
          <Route path="college-offer" element={<Collage_offer />} />
          <Route path="college-global-map" element={<Global_map />} />
          <Route
            path="college-document"
            element={<Collage_portal_documents />}
          />
          <Route path="college-profile" element={<Collage_Profile />} />

          {/* ---------- HOTEL ROUTES ---------- */}
          <Route path="hotel-dashboard" element={<Hotel_dashboard />} />
          <Route path="hotel-intern" element={<Hotel_intern />} />
          <Route
            path="hotel-intern/application"
            element={<Hotel_application />}
          />
          <Route path="hotel-global-map" element={<Hotel_Global_map />} />
          <Route path="hotel-document" element={<Hotel_portal_documents />} />
          <Route path="hotel-profile" element={<Hotel_Profile />} />

          {/* ---------- Admin ROUTES ---------- */}
          <Route path="admin-dashboard" element={<Admin_dashboard />} />
          <Route path="admin-country" element={<Country />} />
          <Route path="admin-state" element={<State />} />
          <Route path="admin-city" element={<City />} />
          <Route path="admin-pincode" element={<Pincode />} />
          <Route path="admin-faq" element={<Faq />} />
          <Route path="admin-student-document" element={<StudentDocument />} />

          <Route path="admin-role" element={<Role />} />
          <Route path="admin-student" element={<Student />} />
          <Route path="admin-college" element={<College />} />
          <Route path="admin-hotel" element={<Hotel />} />
          <Route path="admin-university" element={<University />} />
          <Route path="admin-course" element={<Course />} />
          <Route path="admin-accomodation" element={<Accomodation />} />
          <Route path="admin-studyprogram" element={<Study_Programs />} />
          <Route path="admin-support" element={<Ticket />} />

          <Route
            path="admin-programhighlight"
            element={<Program_Highlight />}
          />
          <Route
            path="admin-eligibilityrequirement"
            element={<Eligibility_Requirement />}
          />
          <Route
            path="admin-careerrequirement"
            element={<Career_Requirement />}
          />
          <Route
            path="admin-requirementdocument"
            element={<Requirement_Documents />}
          />
          <Route path="admin-role" element={<Role />} />
          <Route path="admin-document" element={<Document />} />

          <Route path="admin-requirement" element={<Requirement />} />
          <Route path="admin-internship" element={<Internship />} />

          {/* ------------------------------------------------------------------Website -------------------------------------------------------- */}

          {/* ------------------------------------Home */}
          <Route
            path="admin-website-home-why-choose-us"
            element={<WhyChooseUS />}
          />

          <Route path="admin-website-home-who-we-are" element={<WhoWeAre />} />
          <Route
            path="admin-website-home-success-speaks"
            element={<SuccessSpeaks />}
          />
          <Route path="admin-website-home-faq" element={<HomeFaq />} />

          {/* ------------------------------------Aboutus */}
          <Route path="admin-website-aboutus-ourstory" element={<OurStory />} />

          {/* ------------------------------------Contact Us */}
          <Route
            path="admin-website-contactus-getintouch"
            element={<GetInTouch />}
          />

          {/* Admin Contact us */}
          <Route path="admin-contactus" element={<ContactUs />} />

          {/* Admin Need advice */}
          <Route path="admin-need-advice" element={<NeedAdvice />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
